import { FirewallNetworkItem } from '@nirvana/shared/dtos/types/policies/common';

// sanitize network - remove only whitespaces from the beginning and the end of the string
function sanitizeNetwork(network: string) {
  return network.trim();
}

// sanitize mac - remove only whitespaces from the beginning and the end of the string
function sanitizeMac(mac: string) {
  return mac.trim();
}

// sanitize network item form value to network item
export function sanitizeNetworkItemFormValue(networkItem: FirewallNetworkItem): FirewallNetworkItem {
  return {
    ...networkItem,
    network: sanitizeNetwork(networkItem.network),
    domainMac: sanitizeMac(networkItem.domainMac),
  };
}
